import { getSingleton } from 'fe-lib-singleton';
import { getThemeValue as getThemeValueFallback } from './getThemeValueFallback';
import type {
  AvailableThemes,
  ThemeProvider,
  ThemeValueGetter,
} from 'fe-lib-theme-types';
import { getOverrideTheme } from './overrideTheme';
import { UNSAFE_getThemeValue } from 'fe-lib-theme-provider';

// Fallback theme provider uses the internal legacy theme
const fallbackProvider: ThemeProvider = {
  getThemeValue: getThemeValueFallback,
  getIsBrand2020Active: () => false,
  subscribe: () => () => undefined,
};

export const getThemeProvider = (): ThemeProvider => {
  const regularProvider = getSingleton(
    'fe-lib-theme-provider',
  ) as ThemeProvider;

  if (!regularProvider) {
    return fallbackProvider;
  }

  return {
    ...regularProvider,
    getThemeValue: (getter: ThemeValueGetter, themeName?: AvailableThemes) => {
      themeName = themeName || getOverrideTheme();

      // UNSAFE_getThemeValue contains current implementation vs regularProvider.getThemeValue that contains implementation
      // from x.y.z version set up by the first app that runs the package 'fe-lib-theme-provider' which in this case
      if (themeName) {
        return UNSAFE_getThemeValue(getter, themeName);
      }

      return regularProvider.getThemeValue(getter, themeName);
    },
  };
};
